import { render, staticRenderFns } from "./telegram.vue?vue&type=template&id=7c88948d&scoped=true&"
import script from "./telegram.vue?vue&type=script&lang=js&"
export * from "./telegram.vue?vue&type=script&lang=js&"
import style0 from "./telegram.vue?vue&type=style&index=0&id=7c88948d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c88948d",
  null
  
)

export default component.exports